export default __webpack_public_path__ + "static/img-warburg-serres-dea7566258447d772aa341fc48d6184c.png";